import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRedirectArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRedirectArrow"><Path d="M12 20.9999V7.75C12 5.40279 10.0972 3.5 7.74997 3.5C5.40279 3.5 3.5 5.40277 3.5 7.74995C3.5 10.0971 5.40277 11.9999 7.74995 11.9999H20" stroke="currentColor"/><Path d="M16.5 8L20.5 12L16.5 16" stroke="currentColor"/></CentralIconBase>;
});

export default IconRedirectArrow;
